module.exports = __webpack_public_path__ + "img/logo.1aef7e1d.png";